<script>
  import formasPagamento from '../../formas-pagamento';
  import radio from '~componentes/Radio.vue'; 
  import codItemServicoServico from '~modulos/cod-item-servico/servico'; 
  import Itens from './FormItens.vue';
    
  export default {
    components: { radio, Itens },
    props: {
      solicitacao: {
        type: Object,
        required: true
      },
      edicao: {
        type: Boolean,
        required: false,
        default: false,
      }
    },
    data() {
      return {
        formasPagamento: formasPagamento,
        codItemServico: [],
        configuracao: this.$storage.configuracao(),
      }
    },
    computed: {
      descricaoContador() {
        let quantidadeCaracteres = this.solicitacao.descricao ?
          this.solicitacao.descricao.length : 0;

        return 1500 - quantidadeCaracteres;
      },
      fusp() {
        return this.configuracao.abreviaturaFundacao.toUpperCase() === 'FUSP';
      }
    },
    methods: {
      validar(valido) {
        if (!valido) throw new Error("validacao com erro");
        
        return this.$validator.validateAll();
      },
      limparCamposDocumentoTecnico() {
        if (this.solicitacao.comDocumentoTecnico === 'false') {
          this.solicitacao.documentoTecnico = '';
          this.solicitacao.pedidoCompraProcesso = '';
        }
      },
      listaCodItemServico() {
        return codItemServicoServico
          .lista()
          .then(codItemServico => {
            this.codItemServico = codItemServico;
          });
      },
      calcularDataPagamento() {
        switch (this.solicitacao.formaPagamento) {
          case 0:
          case 2:
            this.solicitacao.dataPagamento = moment().add(7, 'days').format('DD/MM/YYYY');
            break;
          case 1:
            this.solicitacao.dataPagamento = moment().add(30, 'days').format('DD/MM/YYYY');
            break;
        }
      }
    },
    mounted() {
      this.listaCodItemServico();
      this.calcularDataPagamento();
    },
    watch: {
      'solicitacao.comDocumentoTecnico': 'limparCamposDocumentoTecnico'
    }
  }
</script>

<template>
  <div>
    
    <div class="row">
      <div :class="[fusp ? 'col-lg-6' : 'col-lg-4']">
        <div class="form-group required">
          <label class="control-label" for="forma-pagamento">Forma de pagamento</label>

          <select
            class="form-control"
            id="forma-pagamento"
            v-model="solicitacao.formaPagamento"
            @change="calcularDataPagamento">
            <option :value="formaPagamento.id" v-for="formaPagamento in formasPagamento">{{ formaPagamento.nome }}</option>
          </select>
        </div>
      </div>
      
      <div :class="[fusp ? 'col-lg-6' : 'col-lg-4']">
        <div class="form-group required">
          <label class="control-label">Data de vencimento</label>

          <input 
              class="form-control"
              type="text"
              v-model="solicitacao.dataPagamento"
              disabled>
        </div>
      </div>

      <div class="col-lg-4" v-if="!fusp">
        <div class="form-group required" :class="{'has-error': errors.has('valor')}">
          <label class="control-label" for="valor">Valor (R$)</label>

          <input
              type="text"
              class="form-control text-right"
              id="valor"
              v-mascara="'moeda'"
              v-model="solicitacao.valor"
              data-vv-name="valor"
              data-vv-as="valor"
              v-validate="'required|not_zero'">

          <p class="text-danger" v-show="errors.has('valor')">{{ errors.first('valor') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group required" :class="{'has-error': errors.has('idCodItemServico')}">
          <label class="control-label" for="codigo-servico">Código do serviço</label>

          <select
            id="codigo-servico"
            class="form-control"
            v-model="solicitacao.idCodItemServico"
            data-vv-name="idCodItemServico"
            data-vv-as="código do serviço"
            v-validate="'required'">
            <option value="">Selecione...</option>
            <option :value="c.idCodItemServico" v-for="c in codItemServico">{{ c.descricao }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('idCodItemServico')">{{ errors.first('idCodItemServico') }}</p>
        </div>
      </div>
    </div>
    
    <div class="row" v-if="!fusp">
      <div class="col-lg-4">
        <div class="form-group">
          <label class="control-label block">Com entrega de documento técnico?</label>
          
          <radio
              v-model="solicitacao.comDocumentoTecnico"
              selected-value="true"
              type="success"
              :inline="true"
              class="margin-right-10 no-margin-top">
            Sim
          </radio>
          
          <radio
              v-model="solicitacao.comDocumentoTecnico"
              selected-value="false"
              type="success"
              :inline="true">
            Não
          </radio>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="form-group">
          <label class="control-label" for="documento-tecnico">Documento técnico nº</label>

          <input
              type="text"
              class="form-control"
              id="documento-tecnico"
              v-model="solicitacao.documentoTecnico"
              :disabled="solicitacao.comDocumentoTecnico === 'false'"
              maxlength="30">
        </div>
      </div>

      <div class="col-lg-4">
        <div class="form-group">
          <label class="control-label" for="pedido-compra-processo">Pedido compra ou processo</label>

          <input
              type="text"
              class="form-control"
              id="pedido-compra-processo"
              v-model="solicitacao.pedidoCompraProcesso"
              :disabled="solicitacao.comDocumentoTecnico === 'false'"
              maxlength="30">
        </div>
      </div>
    </div>

    <div class="row" v-if="!fusp">
      <div class="col-lg-12">
        <div class="form-group required" :class="{'has-error': errors.has('descricao')}">
          <label class="control-label">Descrição ({{ descricaoContador }})</label>

          <textarea
              class="form-control"
              v-model="solicitacao.descricao"
              data-vv-name="descricao"
              data-vv-as="descrição"
              v-validate="'required'"
              maxlength="1500">
          </textarea>

          <p class="text-danger" v-show="errors.has('descricao')">{{ errors.first('descricao') }}</p>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-lg-12">
        <div class="form-group">
          <label class="control-label">Observação</label>

          <input
            class="form-control"
            type="text"
            v-model="solicitacao.obsFaturamento"
            maxlength="100">
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-lg-12">
        <div class="form-group">
          <label class="control-label">Justificativa</label>

          <textarea
              class="form-control"
              v-model="solicitacao.justificativa">
          </textarea>
        </div>
      </div>
    </div>

    <hr v-if="fusp">
    
    <itens 
      :itens="solicitacao.itens"
      v-if="fusp">
    </itens>
    
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-faturamento/componentes/compartilhado/FormDadosFatura.vue